import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CommonBannerComponent from '../common/CommonBannerComponent';
import FindRubbishCollection from '../components/FindRubbishCollection';
import CollectionsDays from '../components/CollectionsDays';
import { connect } from 'react-redux';
import CustomButton from '../common/CustomButton';
import { useTranslation } from 'react-i18next';
import { fetchCalendarData } from '../redux/slice/calenderSlice';
import { encryptData, getDataFromSessionStorage, getItem } from '../utils/utils';

const RubbishCollection = (props) => {
  const { selectedAddressValue, collectionsList, themeSettingsData, calenderCollectionData, fetchCalendarData } = props;
  const [selectedPostcode, setSelectedPostcode] = useState(selectedAddressValue ? selectedAddressValue : '');
  const [isProcessing, setIsProcessing] = useState(false);
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const accessKeys = getItem('accessKeys');
  const selectedUPRN = getDataFromSessionStorage('selectedUPRN');
  const convertEvents = (events) => {
    return events?.map((event, index) => ({
      uid: index + 1,
      title: `${event.BIN_TYPE} collection`,
      start: `${event.DATE}T00:00:00Z`, // Assuming start of the day; adjust as needed
      end: `${event.DATE}T04:00:00Z`, // Assuming 1 hour duration; adjust as needed
      description: event.DESCRIPTION || '', // Fallback to empty string if DESCRIPTION is not present
      location: selectedAddressValue ? `${selectedAddressValue.label}` : '', // Static location as example
      organizer: { name: 'iTouchVision', email: '' }, // Static organizer
      color: event.COLOR, // Including the color as part of the event object
    }));
  };

  const formatDate = (date) => {
    return date.toISOString().replace(/-|:|\.\d+/g, '');
  };

  // Function to generate ICS content from an array of events
  const generateIcsContent = (events) => {
    let icsContent = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Your Organization//EN'];

    events.forEach((event) => {
      const startDate = formatDate(new Date(event.start));
      const endDate = formatDate(new Date(event.end));
      icsContent.push(
        'BEGIN:VEVENT',
        `UID:${event.uid}@yourdomain.com`,
        `DTSTAMP:${formatDate(new Date())}`,
        `DTSTART:${startDate}`,
        `DTEND:${endDate}`,
        `SUMMARY:${event.title}`,
        event.description ? `DESCRIPTION:${event.description}` : '',
        event.location ? `LOCATION:${event.location}` : '',
        event.organizer ? `ORGANIZER;CN=${event.organizer.name}:MAILTO:${event.organizer.email}` : '',
        'END:VEVENT'
      );
    });

    icsContent.push('END:VCALENDAR');
    return icsContent.join('\r\n');
  };

  // Function to download the ICS file
  const downloadIcsFile = (events) => {
    const icsData = generateIcsContent(events);
    const blob = new Blob([icsData], { type: 'text/calendar;charset=utf-8' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'collections.ics';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const downloadClick = async () => {
    setIsProcessing(true);
    try {
      const apiData = {
        P_UPRN: selectedUPRN,
        P_CLIENT_ID: accessKeys?.P_CLIENT_ID,
        P_ACCESS_KEY: accessKeys?.P_ACCESS_KEY,
        P_COUNCIL_ID: accessKeys?.P_COUNCIL_ID,
        P_TIME_ZONE: 'GMT',
        LANG_CODE: i18n.language.toUpperCase(),
      };
      const encryptedApiData = encryptData(apiData);
      const response = await fetchCalendarData(encryptedApiData);
      if (response) {
        navigate('/calendar', { state: selectedPostcode });
      }
    } catch {
      console.log('error here');
    }
    setTimeout(() => {
      setIsProcessing(false);
    }, 3000);
  };
  return (
    <div>
      <CommonBannerComponent header={t('title')} subTitle={t('subTitle')} isFormHeader={true} />
      <div className="container-xxl rubbishCollectionBox">
        <div className="rubbishCollectionInput">
          <FindRubbishCollection setSelectedPostcode={setSelectedPostcode} />
          <CollectionsDays />
        </div>
        <div className="rubbishCollectionMenu mb-4">
          <div>
            <div style={{ borderTop: `8px solid ${themeSettingsData?.P_THEME?.P_SEP_REG_BG_COLOR ? themeSettingsData?.P_THEME?.P_SEP_REG_BG_COLOR : '#1F70B8'}` }}></div>
            <h2 className="govuk-label-wrapper">
              <label className="govuk-label govuk-label--l mt-2" htmlFor="">
                {t('RelatedContent')}
              </label>
            </h2>
            <div className="d-flex flex-column align-items-start justify-content-between mt-3">
              <div>
                <CustomButton
                  themeSettingsData={themeSettingsData}
                  onClick={async () => {
                    setIsProcessing(true);
                    try {
                      if (calenderCollectionData) {
                        const convertedEvents = convertEvents(calenderCollectionData?.COLLECTION);
                        downloadIcsFile(convertedEvents);
                      } else {
                        const apiData = {
                          P_UPRN: selectedUPRN,
                          P_CLIENT_ID: accessKeys?.P_CLIENT_ID,
                          P_ACCESS_KEY: accessKeys?.P_ACCESS_KEY,
                          P_COUNCIL_ID: accessKeys?.P_COUNCIL_ID,
                          P_TIME_ZONE: 'GMT',
                          LANG_CODE: i18n.language.toUpperCase(),
                        };
                        const encryptedApiData = encryptData(apiData);
                        const response = await fetchCalendarData(encryptedApiData);
                        const convertedEvents = convertEvents(response?.payload?.COLLECTION);
                        downloadIcsFile(convertedEvents);
                      }
                    } catch {
                      console.log('');
                    }
                    setTimeout(() => {
                      console.log('Done!');
                      setIsProcessing(false);
                    }, 3000);
                  }}
                  disable={!collectionsList?.collectionDay?.length > 0 ? true : isProcessing ? true : false}
                >
                  {t('addToYourCalendar')}
                </CustomButton>
              </div>
              <div>
                <CustomButton
                  themeSettingsData={themeSettingsData}
                  onClick={downloadClick}
                  disable={!collectionsList?.collectionDay?.length > 0 ? true : isProcessing ? true : false}
                >
                  {t('viewAndDownload')}
                </CustomButton>
              </div>
            </div>
            {/* <div className="mt-3">Related content</div> */}
            {/* <div className="d-flex flex-column align-items-start justify-content-between mt-3">
              {arr1.map((d) => {
                return (
                  <Button className="p-0" type="text" key={d.id}>
                    <span className="relButtonText" style={{ color: '#1f70b8' }}>
                      {d.name}
                    </span>
                  </Button>
                );
              })}
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = ({ collectionData, calenderData, themeSlice }) => {
  const { themeSettingsData } = themeSlice;
  const { selectedAddressValue, collectionsList } = collectionData;
  const { calenderCollectionData } = calenderData;
  return { selectedAddressValue, collectionsList, calenderCollectionData, themeSettingsData };
};

const mapDispatchToProps = { fetchCalendarData };
export default connect(mapStateToProps, mapDispatchToProps)(RubbishCollection);
